import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconGeo: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="12" viewBox="0 0 12 12" width="12" {...props}>
        <path
            d="M11.934.072a.228.228 0 00-.263-.05L.135 5.444a.24.24 0 00-.133.248.235.235 0 00.192.203l5.174.888.591 5.007a.236.236 0 00.231.21.23.23 0 00.208-.132L11.976.344a.242.242 0 00-.042-.272z"
            fill="currentColor"
        />
    </svg>
);
